import React, { createContext, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18n, { SUPPORTED_LANGS } from "@/i18n";

// Compatibility shim: the codebase uses `useI18n()` from this module with
// `{ lang, t, setLang }`. Internally we now delegate to react-i18next so any
// call site keeps working while gaining live language switching + new locales.

const I18nContext = createContext({ lang: "tr", t: (k) => k, setLang: () => {}, langs: SUPPORTED_LANGS });

export function I18nProvider({ children }) {
  const { t, i18n: i18next } = useTranslation();
  useEffect(() => {
    document.documentElement.setAttribute("lang", i18next.language || "tr");
  }, [i18next.language]);
  const setLang = (l) => {
    if (!SUPPORTED_LANGS.some((x) => x.code === l)) return;
    i18n.changeLanguage(l);
    try { localStorage.setItem("lang", l); } catch { /* ignore */ }
  };
  const lang = (i18next.language || "tr").split("-")[0];
  return (
    <I18nContext.Provider value={{ lang, t, setLang, langs: SUPPORTED_LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
